var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTvMode({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#506D85",
    fillRule: "nonzero",
    stroke: "#506D85",
    strokeWidth: 0.5,
    d: "M19.867 2.638H3.654A2.657 2.657 0 0 0 1 5.29v10.277a2.657 2.657 0 0 0 2.654 2.653h7.503v2.533h-3.74a.6.6 0 0 0-.603.603.6.6 0 0 0 .603.603h8.687a.6.6 0 0 0 .604-.603.6.6 0 0 0-.604-.603h-3.74V18.22h7.503a2.657 2.657 0 0 0 2.654-2.653V5.291a2.654 2.654 0 0 0-2.654-2.653zM3.654 3.844h16.217A1.45 1.45 0 0 1 21.32 5.29v8.589H2.207V5.29c0-.799.648-1.446 1.447-1.446zm16.213 13.171H3.654a1.45 1.45 0 0 1-1.447-1.447v-.482h19.108v.482a1.45 1.45 0 0 1-1.448 1.447z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTvMode);
export default __webpack_public_path__ + "static/media/tv-mode.4837c19d0fa0189571cc19d5b2ae553e.svg";
export { ForwardRef as ReactComponent };